module.exports = __webpack_public_path__ + "static/media/magento2-logo.4cf82deb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/magento2-logo.svg
// module id = 719
// module chunks = 0